import { ResponseType } from 'axios'
import { authorizedEdgeFetch } from 'app/axios/edge'

export const fetchProfiles = (domainId: string) =>
  authorizedEdgeFetch.get(`/config/profiles/domain/${domainId}/true`)

interface FetchProfileFileProps {
  url: string
  responseType: ResponseType
  contentType: string
}

export const fetchProfileFile = ({
  url,
  responseType,
  contentType,
}: FetchProfileFileProps) =>
  authorizedEdgeFetch.get(url, {
    responseType,
    headers: { Accept: contentType },
  })

export const deleteProfile = (profileId: string) =>
  authorizedEdgeFetch.delete(`/config/profiles/${profileId}`)
